import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Override the global error handler
window.onerror = (message, source, lineno, colno, error) => {
  if (message.includes('Invariant failed: Cannot finish a drop animating when no drop is occurring')) {
    console.warn('Suppressed error:', message);
    return true; // Prevent the error from being logged to the console
  }
  return false; // Let other errors be logged to the console
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
